<template>
  <div
    v-if="hasSidebarContent"
    class="top-navigation-desktop h-min bg-gradient-to-tr from-[#F7FBFE] to-[#EFF6FA] px-container-wide py-8 sm:px-container-desktop-wide sm:py-16 xl:sticky xl:px-8 xl:py-10"
  >
    <div class="grid grid-cols-2 gap-5 sm:gap-7 xl:grid-cols-1">
      <!-- COMPANY -->
      <div
        v-if="page.link_text_company"
        class="col-span-2 flex gap-4 md:col-span-1"
      >
        <CompanyIcon class="size-6 shrink-0 text-blue-700" />
        <div class="flex flex-col justify-between">
          <h2 class="mb-[7px] text-sm opacity-60">{{ $t('company') }}</h2>
          <template v-if="page.link_company">
            <AppLink
              :to="page.link"
              class="cursor-pointer font-medium text-blue-dark-900"
              :target="page.target?.value"
            >
              {{ page.link_text_company }}
            </AppLink>
          </template>
          <template v-else>
            <p class="font-medium">{{ page.link_text_company }}</p>
          </template>
        </div>
      </div>

      <!-- PROJECT DURATION -->
      <div
        v-if="page.project_duration"
        class="col-span-2 flex gap-4 md:col-span-1"
      >
        <ProjectTimeIcon class="size-6 shrink-0 text-blue-700" />
        <div class="flex flex-col justify-between">
          <h2 class="mb-[7px] text-sm opacity-60">
            {{ $t('project_duration') }}
          </h2>
          <p class="font-medium">{{ page.project_duration }}</p>
        </div>
      </div>

      <!-- CONTACT PERSON -->
      <div v-if="showContactPerson" class="col-span-2 flex gap-4 md:col-span-1">
        <ContactIcon class="size-6 shrink-0 text-blue-700" />
        <div>
          <h2 class="mb-[7px] text-sm opacity-60">{{ $t('contact') }}</h2>
          <p v-if="page.contact_name" class="mb-1 font-medium">
            {{ page.contact_name }}
          </p>
          <a
            v-if="page.contact_phone"
            class="mb-1 block font-medium transition-colors hover:text-blue-dark"
            :href="`tel:${page.contact_phone}`"
          >
            {{ page.contact_phone }}
          </a>
          <a
            v-if="page.contact_email"
            class="block hyphens-auto font-medium transition-colors hover:text-blue-dark"
            :href="`mailto:${page.contact_email}`"
          >
            {{ page.contact_email }}
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useAuthStore } from '~/stores/auth.js'

const props = defineProps({
  page: { type: Object, required: true },
})

const { isMember, isRegularMember } = useAuthStore()

const showContactPerson = computed(() => {
  const visibility = props.page.contact_visibility.value

  switch (visibility) {
    case 'all':
      return true
    case 'members':
      return isMember || isRegularMember
    case 'regular_members':
      return isRegularMember
  }
})

const hasSidebarContent = computed(() => {
  return (
    props.page.link_text_company ||
    props.page.project_duration ||
    props.page.contact
  )
})
</script>
